import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { DockAppointments_ModuleContextService } from './DockAppointments.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class DockAppointments_areas_dd_ComponentContextService {
  private readonly moduleContext: DockAppointments_ModuleContextService;

  constructor(moduleContext: DockAppointments_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'areas_dd',
      type: ComponentType.selector
    }
  }
}